import { render, staticRenderFns } from "./BrandPriceAdjustment.vue?vue&type=template&id=1643e280&scoped=true&"
import script from "./BrandPriceAdjustment.vue?vue&type=script&lang=js&"
export * from "./BrandPriceAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./BrandPriceAdjustment.vue?vue&type=style&index=0&id=1643e280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643e280",
  null
  
)

export default component.exports